import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function IndustrialIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M6.25021 1C7.15077 4.13325 7.65589 6.42265 7.87248 9.72214L5.91128 10.4334C5.75652 7.52123 5.39112 5.48214 4.73029 3H4.34045C3.65644 5.95833 3.2052 8.05482 3.0548 11.4692L1.02686 12.2046C1.02884 12.1359 1.03093 12.0677 1.03313 12C1.16871 7.82446 1.71232 5.47987 2.50815 2.04745C2.58644 1.70976 2.66718 1.36153 2.75021 1H6.25021Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M6 17H9V19H6V17Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13.5 19V17H10.5V19H13.5Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M15 17V19H18V17H15Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 22.9999V13.6811L14 8.9668V11.9668L23 8.9668V22.9999H1ZM12 14.9999V11.9999L3 14.9999V20.9999H21V11.9999L12 14.9999Z",
    fill: "currentColor"
  }));
}